import { useQuery } from 'react-query';

import { getClient } from '@/lib/restClient';
import {
  BrandSalesStateGroupRulesService,
  GetBrandSalesStateGroupRulesResponse,
} from '@/services/BrandSalesStateGroupRules';

export const useGetBrandSalesStateGroupRules = (
  brandId: number | undefined
) => {
  const { data, error, isLoading, refetch } = useQuery<
    GetBrandSalesStateGroupRulesResponse,
    Error
  >(
    ['brandSalesStateGroupRules', brandId],
    async (): Promise<GetBrandSalesStateGroupRulesResponse> => {
      const service = new BrandSalesStateGroupRulesService(getClient());
      // enabled: brandId !== undefined でガードされているため安全
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return await service.get(brandId!);
    },
    {
      enabled: brandId !== undefined,
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  return {
    rulesData: data,
    isLoading,
    error,
    refetch,
  };
};
